import { TRACKED_METRICS } from './utils'

const getHourlyStorageKey = (userId) => `fitness_hourly_closed_${userId}`
const getDailyStorageKey = (userId) => `fitness_daily_closed_${userId}`

const getCurrentHourKey = () =>
  `${String(new Date().getHours()).padStart(2, '0')}:00`

const getCurrentDateKey = () => new Date().toISOString().split('T')[0]

const getStorage = (key, type) => {
  try {
    const data = JSON.parse(localStorage.getItem(key))

    if (!data) {
      return null
    }

    if (type === 'hourly' && data.hour !== getCurrentHourKey()) {
      localStorage.removeItem(key)
      return null
    }

    if (type === 'daily' && data.date !== getCurrentDateKey()) {
      localStorage.removeItem(key)
      return null
    }

    return data
  } catch {
    return null
  }
}

const setStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
}

const findNewClosures = ({ data, storageKey, storageType }) => {
  const closed = getStorage(storageKey, storageType) ?? {
    ...(storageType === 'hourly'
      ? { hour: getCurrentHourKey() }
      : { date: getCurrentDateKey() }),
    metrics: {},
  }

  const events = []
  let updated = false

  Object.entries(TRACKED_METRICS).forEach(([metricKey, metric]) => {
    const metricData = data?.[metricKey]

    if (!metricData) return

    const hit = metricData.target > 0 && metricData.value >= metricData.target

    if (hit && !closed.metrics[metricKey]) {
      closed.metrics[metricKey] = true

      const isDaily = storageType === 'daily'

      events.push({
        id: `${storageType}-${metricKey}-${Date.now()}`,
        type: storageType,
        metric: metricKey,
        metricLabel: metric.label,
        colour: metric.colour,
        icon: metric.icon,
        value: metricData.value,
        target: metricData.target,
        percentage: Math.round((metricData.value / metricData.target) * 100),
        hour: isDaily ? null : data.hour,
        title: isDaily
          ? `${metric.label} daily target achieved!`
          : `${metric.label} ring closed!`,
        message: isDaily
          ? `Great work! You've reached today's ${metric.label.toLowerCase()} target.`
          : `You've reached your ${metric.label.toLowerCase()} target for ${
              data.hour
            }.`,
      })

      updated = true
    }
  })

  if (updated) {
    setStorage(storageKey, closed)
  }

  return events
}

export const processFitnessAchievements = ({ currentHour, daily, userId }) => {
  if (!userId) return []

  const hourlyEvents = currentHour
    ? findNewClosures({
        data: currentHour,
        storageKey: getHourlyStorageKey(userId),
        storageType: 'hourly',
        prefix: `${currentHour.hour} `,
      })
    : []

  const dailyEvents = daily
    ? findNewClosures({
        data: daily,
        storageKey: getDailyStorageKey(userId),
        storageType: 'daily',
      })
    : []

  return [...hourlyEvents, ...dailyEvents]
}
